  <template>
  <section class="brand-gradient" id="modifySearch">
    <div class="hd-container-fluid">
      <div class="modify-header">
        <div class="package-modify">
          <div class="left-theme-icon">
            <i class="icon icon-holiday-theme"></i>
          </div>
          <div class="modify-form">
            <div class="form-group drop-down-container">
              <input id="holidayDestination" type="text" class="form-field" :class="{'has-value': dropDownConfigs.destination.displayValue}" autocomplete="off" v-model="dropDownConfigs.destination.displayValue" @keydown.up.down.enter.esc="dropDownConfigs.destination.event = $event" @focusout="blurEvent($event, 'destination')">
              <label for="holidayDestination">Destination</label>
              <span class="icon-small-loader" v-if="dropDownConfigs.destination.loading"></span>
              <!-- @blur="dropDownConfigs.destination.show = false"> -->
              <transition name="fade">
                <div class="error-message-container" v-if="showError && dropDownConfigs.destination.displayValue !== destination">
                  <i class="ico ico-left-shadow-caret arrow-left"></i>
                  <div class="popup-info">
                    Please select valid Destination.
                  </div>
                </div>
              </transition>

              <autocomplete v-if="dropDownConfigs.destination.show" :optionsList="dropDownConfigs.destination.options" displayProp="name" valueProp="id" @onselect="optionSelected($event, 'destination')" :eventOnInput="dropDownConfigs.destination.event"></autocomplete>
            </div>
            <div class="form-group drop-down-container">
              <input id="holidayDeparture" type="text" class="form-field" :class="{'has-value': dropDownConfigs.departure.displayValue}" autocomplete="off" v-model="dropDownConfigs.departure.displayValue" @keydown.up.down.enter.esc="dropDownConfigs.departure.event = $event" @focusout="blurEvent($event, 'departure')">
              <label for="holidayDeparture">Departure city</label>

              <span class="icon-small-loader" v-if="dropDownConfigs.departure.loading"></span>
              <!-- @blur="dropDownConfigs.departure.show = false"> -->
              <transition name="fade">
                <div class="error-message-container" v-if="showError && dropDownConfigs.departure.displayValue !== departure">
                  <i class="ico ico-left-shadow-caret arrow-left"></i>
                  <div class="popup-info">
                    Please select valid Departure city.
                  </div>
                </div>
              </transition>

              <autocomplete v-if="dropDownConfigs.departure.show" :optionsList="dropDownConfigs.departure.options" displayProp="name" valueProp="id" @onselect="optionSelected($event, 'departure')" :eventOnInput="dropDownConfigs.departure.event"></autocomplete>

            </div>

            <div class="form-group drop-down-container">
              <input id="holidayMonth" type="text" class="select form-field" :class="{'has-value': dropDownConfigs.monthYear.displayValue}" readonly autocomplete="off" v-model="dropDownConfigs.monthYear.displayValue" @keydown.up.down.enter.esc.prevent="dropDownConfigs.monthYear.event = $event" @focusout="blurEvent($event, 'monthYear')" @focus="dropDownConfigs.monthYear.show = true">
              <label for="holidayMonth">Month</label>

              <autocomplete v-if="dropDownConfigs.monthYear.show" :optionsList="dropDownConfigs.monthYear.options" displayProp="displayName" valueProp="code" @onselect="optionSelected($event, 'monthYear')" :eventOnInput="dropDownConfigs.monthYear.event"></autocomplete>

            </div>
            <button class="btn btn-modify" @click.prevent="modifySearch">modify search</button>
          </div>
        </div>
      </div>
    </div>
    <form method="post" name="modifySearch" action="/holidays/wait.htm" style="display:none">
      <input name="destination" id="hiddendestination" ref="hiddenDestination" />
      <input name="departureCityId" id="hiddenDeparture" ref="hiddenDepartureCityId" />
      <input name="monthYear" id="hiddenMonthYear" ref="hiddenMonthYear" />
    </form>
  </section>
</template>

<script>
import axios from 'axios'
import autocomplete from './autocomplete'

export default {
  name: 'modify-search',
  props: ['initialValues'],
  components: {
    autocomplete
  },
  data() {
    return {
      destinationInputKeyCode: {},
      destination: null,
      departure: '',
      monthYear: '',
      departureCity: null,
      dropDownConfigs: {
        destination: { show: false, options: [], event: {}, invalid: false, displayValue: '', loading: false },
        departure: { show: false, options: [], event: {}, invalid: false, displayValue: '', loading: false },
        monthYear: { show: false, options: [], event: {}, invalid: false, displayValue: '', loading: false }
      },
      showError: false,
      timeOut: null
    }
  },
  created: function() {
    this.monthsList = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
    let initialValuesWatch = this.$watch('initialValues', (newValue, oldValue) => {
      if (newValue) {
        this.setInitialValues(newValue)
        initialValuesWatch()
      }
    })
  },
  mounted: function() {
    if (window.searchMonthList) {
      this.dropDownConfigs.monthYear.options = window.searchMonthList
      this.dropDownConfigs.monthYear.options.unshift({code: '', displayName: 'Any', name: ''})
    }
  },
  methods: {
    setInitialValues: function(initialValues) {
      if (initialValues) {
        if (initialValues.destination) {
          this.destination = initialValues.destination
          this.dropDownConfigs.destination.displayValue = initialValues.destination
        }

        if (initialValues.departure) {
          this.departure = initialValues.departure
          this.dropDownConfigs.departure.displayValue = initialValues.departure
          this.departureCityId = initialValues.departureCityId
        }

        if (initialValues.monthYear) {
          this.monthYear = initialValues.monthYear
          let len = this.dropDownConfigs.monthYear.options.length
          let monthYearDispValue = initialValues.monthYear
          for (let i = 0; i < len; i++) {
            if (this.dropDownConfigs.monthYear.options[i].code === initialValues.monthYear) {
              monthYearDispValue = this.dropDownConfigs.monthYear.options[i].displayName
            }
          }
          this.dropDownConfigs.monthYear.displayValue = monthYearDispValue
        }
      }
    },
    blurEvent: function($event, type) {
      let relatedTarget = $event.relatedTarget
      if (relatedTarget) {
        if (!relatedTarget.classList.contains('drop-down-option')) {
          this.dropDownConfigs[type].show = false
        }
      } else {
        this.dropDownConfigs[type].show = false
      }
    },
    optionSelected: function(eventData, type) {
      if (type == 'departure') {
        this.departureCityId = eventData.selectedOption.id
        this[type] = eventData.selectedOption.name
      } else if(type == 'destination') {
      	this.destination = eventData.selectedOption.name
      } else {
      	this[type] = eventData.selectedOption.value
      }      
      this.dropDownConfigs[type].displayValue = eventData.selectedOption.name
      this.dropDownConfigs[type].show = false
      this.dropDownConfigs[type].invalid = false
    },
    modifySearch: function() {
      if (this.dropDownConfigs.departure.show || this.dropDownConfigs.destination.show) {
        return
      }
      // var reqObj = {}

      if (this.destination && this.destination === this.dropDownConfigs.destination.displayValue) {
        // reqObj.destination = this.destination
        this.$refs.hiddenDestination.value = this.destination
      } else {
        this.showError = true
      }

      if (this.dropDownConfigs.departure.displayValue) {
        if (this.dropDownConfigs.departure.displayValue === this.departure) {
          // reqObj.departureCityId = this.departureCityId
          this.$refs.hiddenDepartureCityId.value = this.departureCityId
        } else {
          this.showError = true
        }
      }

      if (this.showError) {
        setTimeout(() => {
          this.showError = false
        }, 1000)
      } else {
        if (this.dropDownConfigs.monthYear.displayValue) {
          // let dateTokens = this.monthYear.split(' ')
          // let monthIndex = this.monthsList.indexOf(dateTokens[0])
          // let year = Number(dateTokens[1])

          // reqObj.monthYear = this.monthYear
          this.$refs.hiddenMonthYear.value = this.monthYear
          // reqObj.month = monthIndex + 1
          // reqObj.year = year
        }

        document.forms.modifySearch.submit()

        // axios
        //   .post(urls.wait, reqObj, {
        //     headers: {
        //       'Content-Type': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8'
        //     }
        //   })
        //   .then(resp => {
        //     console.log(resp)
        //   })

        // this.$emit('updatePackages', reqObj)
      }
    },
    getLocations: function(searchString, productType) {
      return axios.post('/autosuggest/autosuggest/destinations', {
        autoSuggestQueryWO: { searchPhrase: searchString, product: productType, parentContextId: null },
        autoSuggestCriterionWO: {
          entityTypeCounts: [{ entityType: 'Town', count: 25, startIndex: 0 }, { entityType: 'City', count: 25, startIndex: 0 }, { entityType: 'State', count: 25, startIndex: 0 }, { entityType: 'Country', count: 25, startIndex: 0 }, { entityType: 'Region', count: 25, startIndex: 0 }, { entityType: 'Continent', count: 25, startIndex: 0 }]
        },
        autoSuggestAttributesWO: { attributes: ['id', 'name'] }
      })
    },
    getLocationsFromEntityMap: function(entityMap) {
      var locationsList = []

      for (var x in entityMap) {
        entityMap[x].entityWOs.forEach(y => {
          locationsList.push(y.fieldsMap)
        })
      }

      return locationsList
    },
    processLocationChange: function(type, newValue) {
      this.dropDownConfigs[type].invalid = true
      // if (this.timeOut) {
      //   console.log('clear')
      //   clearTimeout(this.timeOut)
      // }
      if (newValue) {
        // this.timeOut = setTimeout(() => {
        this.dropDownConfigs[type].loading = true
        var promise = this.getLocations(newValue, newValue == 'destination' ? 'HOLIDAY_DESTINATIONS' : 'HOLIDAY_DEPARTURE_CITIES')
        promise
          .then(resp => {
            this.dropDownConfigs[type].loading = false
            var locationsObj = resp.data
            if (locationsObj.responseStatus.code === '200' && locationsObj.count > 0) {
              this.dropDownConfigs[type].options = this.getLocationsFromEntityMap(locationsObj.entityMap)
              this.dropDownConfigs[type].show = true
            } else {
              this.dropDownConfigs[type].options = []
              this.dropDownConfigs[type].show = false
            }
          })
          .catch(() => {
            this.dropDownConfigs[type].loading = false
            this.dropDownConfigs[type].show = false
          })
        // }, 100)
      } else {
        this.dropDownConfigs[type].options = []
      }
    }
  },
  watch: {
    'dropDownConfigs.destination.displayValue': function(newValue) {
      if (this.dropDownConfigs.destination.displayValue !== this.destination) {
        this.processLocationChange('destination', newValue)
      }
    },
    'dropDownConfigs.departure.displayValue': function(newValue) {
      if (this.dropDownConfigs.departure.displayValue != this.departure) {
        this.processLocationChange('departure', newValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped="true">
.modify-form {
  .drop-down {
    color: black;
  }
}
.error-message-container {
  position: absolute;
  z-index: 3;
}

.popup-info {
  box-shadow: 4px 4px 6px 0px rgba(0, 0, 0, 0.4);
  position: relative;
  top: 7px;
  padding: 10px;
  display: block;
  z-index: 1;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 5px;
  color: white;
  font-size: 14px;
}

.arrow-left {
  position: absolute;
  // top: 10px;
  left: 20px;
  width: 0px;
  height: 0px;
  border-right: 7px solid transparent;
  border-left: 7px solid transparent;
  border-bottom: 7px solid rgba(0, 0, 0, 0.7);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  opacity: 1;
  transition: all 0.5s ease;
}

.drop-down-container {
  label {
    color: rgba(255, 255, 255, 0.7);
  }

  .icon-small-loader {
    color: white;
    position: absolute;
    left: 240px;
    top: 5px;
  }

  .icon-small-loader:before {
    -webkit-text-fill-color: initial;
  }

  input::-ms-clear {
    display: none;
  }
}

#modifySearch {
  .form-field + label {
    font-size: 14px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modify-search.vue